import React from 'react';
import { Box, Skeleton } from '@mui/material';

type Props = {
  stage?: any;
  i?: any;
  key?: string;
};
const LoaderComponent: React.FC<Props> = ({ stage, i, key }) => {
  return (
    <Box
      sx={{
        background: '#fff',
        justifyContent: 'center',
        border: '1px solid #DDDBDA !important',
        p: '2.5rem 1rem',
        minHeight: '21.875rem',
        textAlign: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        width: `calc(${100 / 1}%)`,
        margin: '-1px 0 0 30px',
      }}
      key={key || `${stage}-${i}`}
      data-testid={`stage-loader-${i}`}
      id={`stage-loader-${i}`}
    >
      <Skeleton
        variant='rectangular'
        width='100%'
        height='3rem'
        animation='wave'
        sx={{
          mb: 1,
          mt: 4,
          display: 'flex',
          bgcolor: (theme) => theme.palette.neutral?.main,
        }}
      />
      <Skeleton
        variant='rectangular'
        width='100%'
        height='1.5rem'
        animation='wave'
        sx={{
          mb: 2,
          mt: 0.5,
          display: 'flex',
          bgcolor: (theme) => theme.palette.neutral?.main,
        }}
      />
    </Box>
  );
};

export default LoaderComponent;
